import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadAddressBook: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    const result = await axios.get(
      `${baseUrl}/customer/mob/address_books${params ? `?${params}` : ''}`,
    );
    return result.data;
  },
};
